export const ROUTES = {
  HOME: '/',
  AUTH: '/auth',
  POST_SIGNOUT: '/postsignout',
  ADMIN: '/admin',
  ADMIN_ADD_USER: '/admin/add-user',
  ADMIN_USERS: '/admin/all-users',
  ADMIN_ALL_USERS: '/admin/allusers',
  CUSTOMER_DETAILS: '/details/:customerId',
  CUSTOMER_DETAILS_BASE: '/details',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  MODULE_A: '/moduleA',
  ONBOARDING: '/onboarding',
} as const;

export type RouteKey = typeof ROUTES[keyof typeof ROUTES];
